import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
export interface AddItemDialogData
{
    readonly description: string;
}
@Component({
    selector: "add-item-dialog-component",
    templateUrl: "./addItemDialog.tmpl.html",
    standalone: false
})
export class AddItemDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<AddItemDialogComponent>>(MatDialogRef);
    private readonly data = inject<AddItemDialogData>(MAT_DIALOG_DATA);


    get description(): string
    {
        return this.data.description;
    }
}
